var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { connect } from 'react-redux';
import * as AromaticNoteFactory from '../../classes/definitions/product/aromaticNote';
import ApiRequests from '../../classes/http/ApiRequests';
import HttpRequests from '../../classes/http/HttpRequests';
import AromaticNotesList from '../../components/AromaticNotes/AromaticNotesList/AromaticNotesList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from './AromaticNotesReduxProps';
var AromaticNotes = /** @class */ (function (_super) {
    __extends(AromaticNotes, _super);
    function AromaticNotes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.parentId = '-1';
        _this.state = {
            data: [],
        };
        _this.getAllAromaticNotes = function () {
            _this.api
                .getAromaticNotes(_this.parentId)
                .then(function (response) {
                var values = AromaticNoteFactory.createAromaticNotes(response.data);
                _this.setState({ data: values });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим ароматните нотки.', _this.props.history);
            });
        };
        _this.toNewAromaticNote = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId + AppRoutes.aromaticNote.path);
        };
        _this.toEditAromaticNote = function (selectedId) {
            if (selectedId !== '-1') {
                _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId + AppRoutes.aromaticNote.path + ("/" + selectedId));
            }
        };
        _this.toParentProduct = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    AromaticNotes.prototype.componentDidMount = function () {
        this.parentId = _.get(this.props, 'match.params.id', '-1');
        if (this.parentId !== '-1') {
            this.getAllAromaticNotes();
        }
    };
    AromaticNotes.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0410\u0440\u043E\u043C\u0430\u0442\u043D\u0438 \u043D\u043E\u0442\u043A\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewAromaticNote, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u0430 \u0430\u0440\u043E\u043C\u0430\u0442\u043D\u0430 \u043D\u043E\u0442\u043A\u0430"),
                            React.createElement("a", { onClick: this.toParentProduct },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) {
                                _this.messages = el;
                            } }),
                        React.createElement(AromaticNotesList, { gridData: data, messages: this.messages, edit: this.toEditAromaticNote, deleteItem: this.deleteItem }))))));
    };
    return AromaticNotes;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(AromaticNotes);



//////////////////
// WEBPACK FOOTER
// ./src/views/AromaticNote/AromaticNotes.tsx
// module id = 319
// module chunks = 0